import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {TransportRepeat} from '../model/Entities/TransportRepeat';

@Injectable()
export class RepeatTransportService extends ApiService<TransportRepeat> {

    protected apiUrl = 'api/repeat-transport';  // URL to web api

    protected getObjectType(): any {
        return TransportRepeat;
    }
}



// WEBPACK FOOTER //
// /app/src/services/repeat-transport.service.ts